import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ROUTES_PATH } from 'app/constants/Routes';
import { identifyAuthenticatedUser } from 'app/services/tracking/segmentIdentity';
import { DASHBOARD_VERSION_VALUES, MENU_VERSION_VALUES } from 'app/services/userPreferences/types';

import { useThirdPartyGlobalReady } from './useThirdPartyGlobalReady';

const getPeriodicityDescription = (periodicity: number) => {
  switch (true) {
    case periodicity <= 30:
      return "Mensal";
    case periodicity <= 90:
      return "Trimestral";
    case periodicity <= 180:
      return "Semestral";
    case periodicity <= 365:
      return "Anual";
    case periodicity <= 730:
      return "Bianual";
    case periodicity <= 1095:
      return "Trianual";
    default:
      return "Período não definido";
  }
};

export function PageViewsTracker() {
  usePageViews();
  return null;
}

export function usePageViews() {
  const location = useLocation();
  const isAppcuesReady = useThirdPartyGlobalReady("Appcues");
  const user = useSelector((state: any) => state.auth.user);
  const subscriptionStatus = useSelector(
    (state: any) => state?.subscription?.subscription_status
  );
  const group = useSelector((state: any) => state?.app?.group?.name ?? "Sem grupo");

  useEffect(() => {
    const isLogout = window.location.pathname === ROUTES_PATH.AUTH.LOGOUT;

    if (isLogout) {
      return;
    }

    if (user && user.id !== undefined && user.email !== undefined) {
      const identifyTraits: Record<string, unknown> = {
        subscription_status: subscriptionStatus?.info?.status,
      };
      if (subscriptionStatus?.plan_details?.name) {
        identifyTraits.plan_name = subscriptionStatus.plan_details.name;
      }
      identifyAuthenticatedUser(user, identifyTraits);

      const appCuesUserData = {
        nome: user.name ?? 'sem nome',
        email: user.email ?? 'sem email',
        codigo_usuario: user.client_id ?? 0,
        plano: subscriptionStatus?.plan_details?.name ?? 'sem plano',
        grupo: group ?? '',
        periodicidade: getPeriodicityDescription(
          subscriptionStatus?.plan_details?.periodicity ?? 0,
        ),
        trial_days: subscriptionStatus?.plan_details?.trial_days ?? 0,
        erro_pagamento: subscriptionStatus?.info?.has_error ? 'sim' : 'nao',
        fim_periodo: subscriptionStatus?.info?.current_period_end ?? null,
        inicio_periodo: subscriptionStatus?.info?.current_period_start ?? null,
        situacao: subscriptionStatus?.info?.status ?? null,
        meio_de_pagamento: subscriptionStatus?.info?.payment_method ?? null,
        ultima_atualizacao: subscriptionStatus?.info?.latest_update ?? null,
        data_de_criacao: user.created_at ?? null,
        sub_usuario: user.role === 'client' ? 'nao' : 'sim',
        menu_version: MENU_VERSION_VALUES.v2,
        dashboard_version: DASHBOARD_VERSION_VALUES.v2,
        has_oab_monitoring: user.has_oab_monitoring ?? null,
        estudante: user.is_student ? 'sim' : 'nao',
      };
      if (
        user.name !== undefined &&
        user.client_id !== undefined &&
        subscriptionStatus?.plan_details !== undefined
      ) {
        (window as any).Appcues?.identify?.(user.id, appCuesUserData);
      }
    }
  }, [location, user, subscriptionStatus, group, isAppcuesReady]);
}
